"use client";

import { c as _c } from "react/compiler-runtime";
import { store } from '@/redux/store';
import { SessionProvider } from 'next-auth/react';
import { Provider } from 'react-redux';
import AuthProvider from './AuthProvider';
const AppProviders = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <SessionProvider><Provider store={store}><AuthProvider>{children}</AuthProvider></Provider></SessionProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default AppProviders;